import React from 'react';
import styled from 'styled-components';
import FlatButton from './input/FlatButton';
import Spacer from './Spacer';

const Container = styled.div`
  box-shadow: 0px 3px 11px #0000000d;
  border-radius: 9px;
`;

const ActionSection = styled.div`
  padding: 0px 27px;
  border: 1px solid #ecedf7;
  border-radius: 9px;
`;

const Divider = styled.div`
  width: 100%;
  background: #ecedf7;
  height: 1px;
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px;
`;

const ActionTitle = styled.div`
  color: #3f456f;
  font-size: 14px;
  font-weight: 500;
`;

const ActionText = styled.div`
  font-size: 14px;
  color: #9092c1;
`;

const ActionInfo = styled.div`
  display: flex;
`;

export type Action = {
  title: string;
  description: string;
  actionText: string;
  onClick: () => void;
};

type Props = {
  title: string;
  description: string;
  actions: Action[];
};

export function ActionList({ actions, description, title }: Props) {
  return (
    <Container>
      <ActionSection>
        {actions.map((action, index) => (
          <>
            <ActionContainer>
              <ActionInfo>
                <ActionTitle>{action.title}</ActionTitle>
                <Spacer horizontal spacing={2} />
                <ActionText>{action.description}</ActionText>
              </ActionInfo>
              <FlatButton
                onClick={action.onClick}
                darkenOnHover
                color={'#5C6EF8'}
              >
                {action.actionText}
              </FlatButton>
            </ActionContainer>
            {index !== actions.length - 1 && <Divider />}
          </>
        ))}
      </ActionSection>
    </Container>
  );
}
